// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.countSpace.MuiTypography-root {
  margin-left: 30px;
}

.valueSpace.MuiTypography-root {
  margin-left: 34px;
}

.refundMainDiv {
  height: 650px;
}

.refundCardDiv {
  width: 22.1%;
  height: 114px;
  border: 1px solid #ececec;
  border-radius: 20px;
  margin-top: 32px;
  margin-left: 24px;
  flex-direction: column;
  display: inline-flex;
  padding-top: 16px;
  padding-left: 16px;
}

.refundChartDiv {
  width: auto;
  height: 480px;
  padding-left: 47px;
  padding-right: 47px;
}

.refundSecondDiv {
  border-radius: 16px;
  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));
  background: var(--primary-accent-sub-2, #f0f5ff);
  width: 100%;
  margin-top: 32px;
}

.refundDownloadDiv {
  margin-top: 30px;
  margin-right: 30px;
  cursor: pointer;
  float: right;
}

.refundTabsDiv {
  margin-top: 32px;
  margin-left: 32px;
}

.refund-analytics-contnet {
  display: grid;
  grid-template-columns: calc(55% - 28px) 45%;
  column-gap: 24px;
  row-gap: 28px;
  margin-top: 28px;
}

.refund-analytics-contnet > div:first-child {
  grid-column: 1 / span 2;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/analytics/refund/refund.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,+DAA+D;EAC/D,gDAAgD;EAChD,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":[".countSpace.MuiTypography-root {\n  margin-left: 30px;\n}\n\n.valueSpace.MuiTypography-root {\n  margin-left: 34px;\n}\n\n.refundMainDiv {\n  height: 650px;\n}\n\n.refundCardDiv {\n  width: 22.1%;\n  height: 114px;\n  border: 1px solid #ececec;\n  border-radius: 20px;\n  margin-top: 32px;\n  margin-left: 24px;\n  flex-direction: column;\n  display: inline-flex;\n  padding-top: 16px;\n  padding-left: 16px;\n}\n\n.refundChartDiv {\n  width: auto;\n  height: 480px;\n  padding-left: 47px;\n  padding-right: 47px;\n}\n\n.refundSecondDiv {\n  border-radius: 16px;\n  border: 1.2px solid var(--border-tertiary, rgba(1, 1, 2, 0.12));\n  background: var(--primary-accent-sub-2, #f0f5ff);\n  width: 100%;\n  margin-top: 32px;\n}\n\n.refundDownloadDiv {\n  margin-top: 30px;\n  margin-right: 30px;\n  cursor: pointer;\n  float: right;\n}\n\n.refundTabsDiv {\n  margin-top: 32px;\n  margin-left: 32px;\n}\n\n.refund-analytics-contnet {\n  display: grid;\n  grid-template-columns: calc(55% - 28px) 45%;\n  column-gap: 24px;\n  row-gap: 28px;\n  margin-top: 28px;\n}\n\n.refund-analytics-contnet > div:first-child {\n  grid-column: 1 / span 2;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
